const Routes = [
  {
    path: '/price-campaigns',
    name: 'PriceCampaigns',
    component: () => import('@/app/price_campaign/views/PriceFetchResults'),
    meta: {
      requiresAuth: true
    }
  }
]

export default Routes



// WEBPACK FOOTER //
// ./src/app/price_campaign/Routes.js